import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { of } from 'rxjs/internal/observable/of';

@Injectable({
  providedIn: 'root'
})
export class BoardStateService {

  constructor() { }

  private mockSavedColors = {
    colors: ["#000000", "#111111", "#222222"]
  };

  public getBoardColors(): Observable<string[]>{
    return of(this.mockSavedColors.colors);
  }
}



